import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";

class CompanySettingsEdit extends Component {
  static propTypes = {
    fetchCompanySettings: PropTypes.func.isRequired,
    updateCompanySettings: PropTypes.func.isRequired,
    settings: PropTypes.object
  };

  onSubmit(state) {
    toastr.success("Settings saved!");
 }

  render() {
    return (
      <div>
        <h1>Help</h1>
        <h2>Training Videos</h2>
        <div className="embed-responsive embed-responsive-16by9">
          <iframe
            className="embed-responsive-item"
            src="//www.youtube.com/embed/TaW0EqQ2kI8"
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(
  mapStateToProps,
  {}
)(CompanySettingsEdit);
